'use client';

import { LinkList, LinkListItem } from '@petsmart-ui/sparky';
import cn from 'classnames';

import { Accordion } from '@libs/shared-ui/components/Accordion';

import { parseRichText } from '../../../../utils/parseRichText';
import { FaqStoreCard } from '../faq-store-card';
import type { FaqItem } from '../types';

type FaqAccordionGroupProps = Readonly<{
    items: FaqItem[];
}>;

function renderAccordionContent(content: FaqItem['content']) {
    switch (content.type) {
        case 'links':
            return (
                <LinkList className="faq-list">
                    {content.links.map(link => (
                        <LinkListItem key={link.id} text={link.text} href={link.href} />
                    ))}
                </LinkList>
            );
        case 'rich-text':
            return <div className="faq-list">{parseRichText(content.document)}</div>;
        case 'stores':
            return (
                <div className="faq-store-cards">
                    {content.stores.map(card => (
                        <FaqStoreCard key={card.id} {...card} />
                    ))}
                </div>
            );
    }
}

export function FaqAccordionGroup({ items }: FaqAccordionGroupProps) {
    return (
        <div className="faq-accordion-group">
            <Accordion
                className="faq-accordions"
                items={items.map(item => ({
                    id: item.id,
                    title: item.title,
                    className: cn({ 'faq-question': item.content.type === 'rich-text' }),
                    children: renderAccordionContent(item.content),
                }))}
            />
        </div>
    );
}
